// extracted by mini-css-extract-plugin
export var sbShowMain = "splitList-module--sb-show-main--2F6cn";
export var splitList = "splitList-module--splitList--XkJqq";
export var article = "splitList-module--article--3DzAI";
export var title = "splitList-module--title--1u77P";
export var img = "splitList-module--img--3YHyC";
export var body = "splitList-module--body--26t3m";
export var buttonsWrapper = "splitList-module--buttonsWrapper--39Mil";